import { appActionTypes } from 'src/@app/newActionTypes';

export const updateUserConfig = (dispatcher, updatedConfigs): void => {
  dispatcher({ type: appActionTypes.UPDATE_USER_CONFIG, payload: updatedConfigs });
};
